export default __webpack_public_path__ + "751152f425d023d69528e1f256f324e9.svg";